import React from "react";

export default function IndicatorScoreSection({ children }) {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        alignItems: "center",
        marginTop: 16,
        marginLeft: 10,
        marginRight: 20,
        marginBottom: 4,
      }}
    >
      {children}
    </div>
  );
}
